var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"me-3"},[_vm._v(_vm._s(_vm.$t(_vm.name)))]),_c('BSwitch',{attrs:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }